import { useActionless, useAppSelector } from 'redux/hooks'
import { SET_FOLDER_STATE } from 'redux/folders/actions/types'

import DynamicFolderTableItem, { DynamiTableHeader } from './DynamicTableItems'

import styles from './folderTable.module.scss'

const FolderTable = () => {
  const parentFolderId = useAppSelector(state => state.folders.rootFolder.parentFolder?.id)
  const subfolders = useAppSelector(state => state.folders.rootFolder.subfolders)
  const decks = useAppSelector(state => state.folders.rootFolder.decks)
  const selectedFolders = useAppSelector(state => state.folders.selectedSubfolders)
  const selectedDecks = useAppSelector(state => state.folders.selectedDecks)
  const autoColumns = useAppSelector(state => state.folders.autoColumns)

  const [setFolderState] = useActionless(SET_FOLDER_STATE)

  return (
    <div className={`${styles.table} ${!autoColumns ? styles.bigTable : ''}`}>
      <DynamiTableHeader />

      {parentFolderId && (
        <DynamicFolderTableItem
          key={`folder-${parentFolderId}`}
          type="folder"
          // Parent folder stand-in
          // @ts-ignore
          deckOrFolder={{ id: parentFolderId, name: '', createdAt: '', private: false }}
          selected={!!selectedFolders[parentFolderId]}
          onToggleSelected={() =>
            setFolderState({
              selectedSubfolders: { ...selectedFolders, [parentFolderId]: !selectedFolders[parentFolderId] },
            })
          }
        />
      )}

      {subfolders.map(subFolder => (
        <DynamicFolderTableItem
          key={`folder-${subFolder.id}`}
          type="folder"
          deckOrFolder={subFolder}
          selected={!!selectedFolders[subFolder.id]}
          onToggleSelected={() =>
            setFolderState({
              selectedSubfolders: { ...selectedFolders, [subFolder.id]: !selectedFolders[subFolder.id] },
            })
          }
        />
      ))}

      {decks.map(deck => (
        <DynamicFolderTableItem
          key={`deck-${deck.id}`}
          type="deck"
          deckOrFolder={deck}
          selected={!!selectedDecks[deck.id]}
          onToggleSelected={() =>
            setFolderState({ selectedDecks: { ...selectedDecks, [deck.id]: !selectedDecks[deck.id] } })
          }
        />
      ))}
    </div>
  )
}

export default FolderTable
